import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

export interface NormaRispostaVsme {
  codiceNormaVsme: string;
  descrizioneNormaVsme: string;
}

@Component({
  selector: 'app-norma-vsme-bottomsheet',
  standalone: false,

  templateUrl: './norma-vsme-bottomsheet.component.html',
  styleUrl: './norma-vsme-bottomsheet.component.scss',
})
export class NormaVsmeBottomsheetComponent {
  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<NormaVsmeBottomsheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      normaRisposta: NormaRispostaVsme;
      risposta: string;
    },
  ) {}

  salva() {
    this.bottomSheetRef.dismiss(this.data.normaRisposta);
  }
}
